import {
  RoundRobinAvailableAttendees,
  ReservationUsers,
} from '@chilipiper/api-client/src/user-availability'
import { MeetingLimitSource } from '../../load-availability-options'

export const getRecheduleReservationUsers = ({
  availableRoundRobinAssignees,
  userIds,
  meetingLimit,
  additionalAttendees,
}: {
  availableRoundRobinAssignees: RoundRobinAvailableAttendees[]
  userIds: string[]
  meetingLimit?: MeetingLimitSource
  additionalAttendees: string[]
}): ReservationUsers => {
  if (availableRoundRobinAssignees.length > 0) {
    return {
      type: 'DistributionUsers',
      attendeesFromDistribution: availableRoundRobinAssignees.map(user => {
        if (user.type === 'StrictRoundRobin') {
          return {
            userId: user.userId,
            distributionId: user.distributionId,
          }
        }
        return {
          userId: user.userIds[0],
          distributionId: user.distributionId,
        }
      }),
      additionalAttendees: additionalAttendees.length > 0 ? additionalAttendees : undefined,
    }
  }
  return {
    type: 'UsersWithLimit',
    userIds,
    limit: meetingLimit ?? { type: 'NoMeetingLimit' },
  }
}
